import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["seed", "challenge"]

  connect() {
    const seed = this.seedTarget.value
    if (seed) {
      const timestamp = Math.floor(Date.now() / 1000)
      const payload = `${seed}|${timestamp}`
      this.challengeTarget.value = btoa(payload)
    }
  }
}
